export type OrderMarginTone = 'loss' | 'watch' | 'positive' | 'strong';

const ORDER_MARGIN_THRESHOLDS = {
  positive: 10,
  strong: 25,
} as const;

export function getOrderMarginTone(
  marginAmount: number,
  marginPercent: number,
): OrderMarginTone {
  if (marginAmount < 0 || marginPercent < 0) return 'loss';
  if (marginPercent < ORDER_MARGIN_THRESHOLDS.positive) return 'watch';
  if (marginPercent < ORDER_MARGIN_THRESHOLDS.strong) return 'positive';
  return 'strong';
}
